import type { Location } from '@core/locations-types';

export const translatableLocationFields: Array<
  keyof Pick<Location, 'name' | 'note' | 'city' | 'street' | 'postalCode'>
> = ['name', 'note', 'city', 'street', 'postalCode'];
